import type { ForcedSubject, MongoAbility } from "@casl/ability";

// IMPORTANT: keep Action / Subjects / AppAbility byte-identical to the backend
// definition in nest_backend/src/common/access/ability.types.ts — the client
// rebuilds the very same ability from rules packed by the server.
export enum Action {
  // `manage` is CASL's wildcard — matches any action.
  Manage = "manage",
  Read = "read",
  Update = "update",
  Delete = "delete",
  Create = "create",
  ManageTeam = "manage_team",
  Export = "export",
  // Granted per organization from its feature rows, not per role
  ManagePrices = "manage_prices",
}

export interface ProjectSubject {
  id?: number;
  organizationId?: number | null;
}

export type Subjects =
  | "all"
  | "Project"
  | (ProjectSubject & ForcedSubject<"Project">);

export type AppAbility = MongoAbility<[Action, Subjects]>;
